import React from 'react'
import { useInfiniteQuery } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { AutoFetchButton } from '@core/Components/AutoFetchButton'
import { getCopiedBetsFeed } from '@core/Areas/BetLoop/helpers/api'
import { BetLoopFeedPageSize } from '@core/Areas/BetLoop/constants'

export const useCopiedBetsData = () => {
  const { data, isLoading, refetch, isRefetching, fetchNextPage, isFetchingNextPage } =
    useInfiniteQuery({
      queryKey: queryKeys.betLoopSharedBetsFeedBase('copied'),

      queryFn: ({ pageParam }: { pageParam: number | null }) => getCopiedBetsFeed({ pageParam }),

      initialPageParam: null,

      getNextPageParam: lastPage => {
        if (!lastPage || lastPage.length < BetLoopFeedPageSize) return undefined
        return lastPage[lastPage.length - 1]?.postId ?? undefined
      },

      staleTime: 1_000 * 60 * 2, // 2min
      gcTime: 1_000 * 60 * 5, // 5min
      refetchOnMount: 'always',
      refetchOnWindowFocus: false,
    })

  const isEmptyState = data?.pages?.[0]?.length === 0
  const isFinalPage = data && data.pages[data.pages.length - 1].length < BetLoopFeedPageSize

  return {
    data,
    isLoading,
    refetch,
    isRefetching,
    LoadMoreButton: () =>
      isFinalPage || isEmptyState || isLoading ? null : (
        <AutoFetchButton onClick={fetchNextPage} isFetching={isFetchingNextPage} />
      ),
  }
}
